import type { ThreadSummary } from "@nabla/api";
import { viewOf } from "./request.ts";
import type { Views } from "./views.ts";

interface PlacesDeps {
  readonly views: Pick<Views, "held" | "entry" | "outOfDate">;
  readonly unheard: () => void;
}

const mine = viewOf("conversas")();
export const myList = mine.key;
const listing = (key: string) => key === myList || key.startsWith(`${myList}?`);
const openThread = (key: string) => key.startsWith(`${myList}/`) && /^c-\d+$/.test(key.slice(myList.length + 1));
const personal = (key: string) => listing(key) || openThread(key);

export function createPlaces({ views, unheard }: PlacesDeps) {
  let opened = false;
  const reread = () => {
    for (const key of views.held().filter(personal)) views.outOfDate(key);
  };
  return {
    reread,
    listed(): readonly ThreadSummary[] | undefined {
      const held = views.entry(myList)?.held;
      const read = held === undefined ? undefined : mine.read(held);
      return read?.ok ? read.value.items : undefined;
    },
    opened(): void {
      unheard();
      if (opened) reread();
      opened = true;
    },
    forget(): void {
      opened = false;
    },
  };
}
